import template from "./../templates/zoomComponent.dust";

import {
  CLICKED_ZOOM_SLIDER_READER,
  ZOOM_PAGE_IN_READER_ON_DESKTOP,
  ZOOM_PAGE_OUT_READER_ON_DESKTOP,
} from "./../../../common/analytics/analyticsevents";

const noUiSlider = require("nouislider");

export default class ZoomComponent {
  constructor(readerComponent, options, appState) {
    this._readerComponent = readerComponent;
    this._appState = appState;
    this._options = options;
    this.zoomScale = 1;
    this.desktopMaxZoom = appState.isDoublePage
      ? this._options.desktopMaxZoom.doublePageMode
      : this._options.desktopMaxZoom.singlePageMode;
    this.zoomStep = (this.desktopMaxZoom - 1) / this._options.zoomSteps;
    this._DOMContainer = document.querySelector("#zoom-component");
  }

  render() {
    Dust.render(template, {}, this._renderDone.bind(this));
  }

  reset() {
    this.zoomScale = 1;
    this._checkZoomActivation();
    this.setProgress();
  }

  setProgress(zoomScale) {
    this.zoomScale = zoomScale || this.zoomScale;
    this.slider.noUiSlider.set(
      ((zoomScale || this.zoomScale) - 1) / this.zoomStep
    );
    this._checkZoomActivation();
  }

  getZoomLevel() {
    return 1 + this.zoomStep * parseInt(this.slider.noUiSlider.get(), 10);
  }

  destroy() {
    this.slider.noUiSlider.destroy();
    this._DOMContainer.innerHTML = "";
  }

  ////////////

  _renderDone(err, result) {
    if (err) return;
    this._DOMContainer.innerHTML = result;
    this._createSlider();
    this._checkZoomActivation();
    this._attachEventListeners();
  }

  _zoom(zoomScale) {
    const oldScale = this.zoomScale;
    this.zoomScale = Math.max(
      1,
      Math.min(this.desktopMaxZoom, Math.round(zoomScale * 10000) / 10000)
    );
    const newScale = this.zoomScale;
    this._checkZoomActivation();
    this._readerComponent.zoomCenterPoint(zoomScale);
    if (oldScale < newScale) {
      this._appState.triggerEvent(ZOOM_PAGE_IN_READER_ON_DESKTOP);
    } else {
      this._appState.triggerEvent(ZOOM_PAGE_OUT_READER_ON_DESKTOP);
    }
  }

  _attachEventListeners() {
    const zoomIn = this._DOMContainer.querySelector("#zoom-in-button");
    zoomIn.addEventListener("click", () => {
      this._zoom(this.zoomScale + this.zoomStep);
      this.setProgress();
    });
    const zoomOut = this._DOMContainer.querySelector("#zoom-out-button");
    zoomOut.addEventListener("click", () => {
      this._zoom(this.zoomScale - this.zoomStep);
      this.setProgress();
    });
  }

  _checkZoomActivation() {
    const zoomIn = this._DOMContainer.querySelector("#zoom-in-button");
    if (zoomIn && this.zoomScale >= this.desktopMaxZoom) {
      zoomIn.classList.add("inactive");
    } else if (zoomIn) {
      zoomIn.classList.remove("inactive");
    }

    const zoomOut = this._DOMContainer.querySelector("#zoom-out-button");
    if (zoomOut && this.zoomScale === 1) {
      zoomOut.classList.add("inactive");
    } else if (zoomOut) {
      zoomOut.classList.remove("inactive");
    }
  }

  _createSlider() {
    this.slider = $(".slider-zoom")[0];

    noUiSlider.create(
      this.slider,
      {
        start: 0,
        connect: [true, false],
        step: 1,
        range: {
          min: 0,
          max: this._options.zoomSteps,
        },
      },
      true
    );

    this.slider.noUiSlider.on("slide", () => {
      this._appState.triggerEvent(CLICKED_ZOOM_SLIDER_READER);
      this._zoom(
        1 + this.zoomStep * parseInt(this.slider.noUiSlider.get(), 10)
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/zoomComponent.js